module.exports = __webpack_public_path__ + "img/tva.89f447b6.svg";